import { AppDispatch, Store } from 'store';
import fetchPricesOperation from 'store/price/operation/fetchPricesOperation';
import setPricesToFetchOperation from 'store/price/operation/setPricesToFetchOperation';
import getPrice from 'store/price/selector/getPrice';
import { PricesToFetch } from 'store/price/types';
import getBundleGroups from 'utils/StudioSearchProductPage/getBundleGroups';

const getProductIds = (arr: { productId: number }[] | null | undefined): number[] =>
  arr ? arr.map(({ productId }) => productId) : [];

const merge = (...arrays: Array<number[] | null | undefined>) => {
  const set = new Set(arrays.flatMap((a) => a || []));
  return [...set.values()];
};

const fetchPublicAssetProductPrices = () => async (dispatch: AppDispatch, getState: () => Store) => {
  const { publicAssetProduct } = getState();
  const { abstractProducts, publicAssetAbstractProductData } = publicAssetProduct;

  if (!publicAssetAbstractProductData) {
    return;
  }

  const prices = publicAssetAbstractProductData.products.reduce((result, { categoryId, slug }) => {
    const abstractProduct = abstractProducts[slug];

    if (!abstractProduct) {
      return result;
    }

    return getBundleGroups(abstractProduct.initialProduct.productId, abstractProduct)
      .flatMap((bundleGroup) => bundleGroup.items || [])
      .reduce(
        (acc, { productId: itemProductId, categoryId: itemCategoryId }) => {
          if (!itemProductId || !itemCategoryId || getPrice(getState(), itemCategoryId, itemProductId, 1)) {
            return acc;
          }
          return {
            ...acc,
            [itemCategoryId]: {
              categoryId: itemCategoryId,
              productIds: merge(acc[itemCategoryId]?.productIds, [itemProductId]),
            },
          };
        },
        {
          ...result,
          [categoryId]: {
            categoryId,
            productIds: merge(result[categoryId]?.productIds, getProductIds(abstractProduct.products)),
          },
        } as PricesToFetch,
      );
  }, {} as PricesToFetch);

  dispatch(setPricesToFetchOperation(prices));
  dispatch(fetchPricesOperation());
};

export default fetchPublicAssetProductPrices;
